<template>
    <div>
        <modal name="pay-invoices-modal" height="auto" width="800px" :adaptive="false" :scrollable="true" @closed="clearData">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <h3 class="mt-2 mb-2">Pay Invoices</h3>
                        <hr />
                            <div class="row" v-if="isConfirmationState">
                                <div class="col-12 text-center">
                                    <h4>Are you sure you want to pay?</h4>
                                    <h3 v-if="this.invoicesForPaymentByCurrencyBalance('SEK') > 0">
                                        {{this.invoicesForPaymentByCurrencyBalance("SEK")}} SEK
                                    </h3>
                                    <h3 v-if="this.invoicesForPaymentByCurrencyBalance('GBP') > 0">
                                        {{this.invoicesForPaymentByCurrencyBalance("GBP")}} GBP
                                    </h3>
                                    <div class="row mt-3">
                                        <div class="col-6 text-center">
                                            <vbutton
                                                v-on:click="pay()"
                                                class="btn-success"
                                                :text="'Pay'">
                                            </vbutton>
                                        </div>
                                        <div class="col-6 text-center">
                                            <vbutton
                                                v-on:click="cancelConfirmation()"
                                                class="btn-danger"
                                                :text="'Cancel'">
                                            </vbutton>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row" v-else>
                                <div class="col-6 text-center">
                                    <h5>Overdue balance:</h5>
                                    <h5>
                                        <b>{{this.overdueBalanceByCurrency('SEK')}} SEK</b>
                                    </h5>
                                    <h5>
                                        <b>{{this.overdueBalanceByCurrency('GBP')}} GBP</b>
                                    </h5>
                                    <vbutton
                                        v-if="!paymentsInProcess"
                                        v-on:click="showConfirmation(overdueInvoices)"
                                        class="btn-success mt-3"
                                        text="Pay Overdue"
                                        style="width: 108px"
                                    />
                                </div>
                                <div class="col-6 text-center">
                                    <h5>Total balance:</h5>
                                    <h5>
                                        <b>{{this.payableInvoicesByCurrencyBalance("SEK")}} SEK</b>
                                    </h5>
                                    <h5>
                                        <b>{{this.payableInvoicesByCurrencyBalance("GBP")}} GBP</b>
                                    </h5>
                                    <vbutton v-if="!paymentsInProcess"
                                        v-on:click="showConfirmation(payableInvoices)"
                                        class="btn-success mt-3"
                                        text="Pay All">
                                    </vbutton>
                                </div>
                            </div>
                        <hr />
                        <div class="row">
                            <div class="col-8">
                                <div v-if="totalChargedSEK > 0 || totalNotChargedSEK > 0 || totalAlreadyPaidSEK > 0">
                                    <div>
                                        Success: <span style="color: green" class="mt-3">{{ totalChargedSEK }} SEK</span>
                                    </div>
                                    <div>
                                        Failed: <span style="color: red" class="mt-3">{{ totalNotChargedSEK }} SEK</span>
                                    </div>
                                    <div>
                                        Already Paid: <span style="color: deepskyblue" class="mt-3">{{ totalAlreadyPaidSEK }} SEK</span>
                                    </div>
                                </div>
                                <div v-if="totalChargedGBP > 0 || totalNotChargedGBP > 0 || totalAlreadyPaidGBP > 0">
                                    <div>
                                        Success: <span style="color: green" class="mt-3">{{ totalChargedGBP }} GBP</span>
                                    </div>
                                    <div>
                                        Failed: <span style="color: red" class="mt-3">{{ totalNotChargedGBP }} GBP</span>
                                    </div>
                                    <div>
                                        Already Paid: <span style="color: deepskyblue" class="mt-3">{{ totalAlreadyPaidGBP }} GBP</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-4">
                                <vbutton v-if="!paymentsInProcess"
                                    v-on:click="$modal.hide('pay-invoices-modal')"
                                    :text="'Close'"
                                    class="float-right mb-3"
                                >
                                </vbutton>
                                <vbutton v-if="paymentsInProcess"
                                         v-on:click="cancelClicked = true"
                                         :text="'Cancel'"
                                         class="btn-warning float-right mb-3"
                                >
                                </vbutton>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </modal>
        <vbutton
                 v-on:click="$modal.show('pay-invoices-modal')"
                 class="btn-primary float-right payAll"
                 :text="'Pay All'">
        </vbutton>
    </div>
</template>

<script>
export default {
    props: ['invoices'],
    data() {
        return {
            invoicesForPayment: null,
            paymentsInProcess: false,
            payClicked: false,
            cancelClicked: false,
            isConfirmationState: false,
            totalChargedSEK: 0,
            totalNotChargedSEK: 0,
            totalAlreadyPaidSEK: 0,
            totalAlreadyPaidGBP: 0,
            totalChargedGBP: 0,
            totalNotChargedGBP: 0,
        };
    },
    computed:{
        payableInvoices(){
            return this.invoices.filter(invoice => this.isPayable(invoice));
        },
        overdueInvoices(){
            return this.payableInvoices.filter(invoice => this.isOverdue(invoice));
        },
    },
    methods: {
        overdueBalanceByCurrency(currency){
            let balance = 0;
            let overdueByCurrency = this.filterByCurrency(this.overdueInvoices, currency)
                overdueByCurrency.forEach(invoice => balance += invoice.balance);
            return balance;
        },
        invoicesForPaymentByCurrencyBalance(currency){
            let balance = 0;
            if(this.invoicesForPayment){
                let invoicesByCurrency = this.filterByCurrency(this.invoicesForPayment, currency);
                invoicesByCurrency.forEach(invoice => balance += invoice.balance);
            }
            return balance;
        },
        payableInvoicesByCurrencyBalance(currency){
            let balance = 0;
            if(this.payableInvoices){
                let invoicesByCurrency = this.filterByCurrency(this.payableInvoices, currency);
                invoicesByCurrency.forEach(invoice => balance += invoice.balance);
            }
            return balance;
        },
        getCurrency(invoice){
            if (invoice.order) {
                return invoice.order.currency;
            } else if (invoice.client.location.toLowerCase() === 'united kingdom') {
                return 'GBP';
            } else if (invoice.client.location.toLowerCase() === 'sweden') {
                return 'SEK';
            }
            return "-"
        },
        filterByCurrency(invoices, currency){
            return invoices.filter(invoice => this.getCurrency(invoice) === currency);
        },
        isOverdue(invoice) {
            return (new Date(invoice.due_date)).setHours(0,0,0,0) < (new Date()).setHours(0,0,0,0);
        },
        isPayable(invoice) {
            return invoice.balance > 0
                && this.getCard(invoice)
                && (!invoice.order || invoice.order.contract_status.toLowerCase() !== 'terminate');
        },
        getCard(invoice) {
            return invoice.client.cards.find(card => card.default == true || card.default == 1);
        },
        showConfirmation(invoices){
            this.isConfirmationState = true;
            this.invoicesForPayment = invoices;
        },
        cancelConfirmation(){
            this.isConfirmationState = false;
            this.invoicesForPayment = null;
        },
        pay() {
            this.isConfirmationState = false;
            this.paymentsInProcess = true;

            this.totalChargedSEK = 0;
            this.totalNotChargedSEK = 0;
            this.totalChargedGBP = 0;
            this.totalNotChargedGBP = 0;
            this.totalAlreadyPaidSEK = 0;
            this.totalAlreadyPaidGBP = 0;

            const invoices = this.invoicesForPayment;
            invoices.reduce(
                (p, invoice) => p.then(_ => new Promise((resolve) => {
                    if (this.cancelClicked === true) {
                        resolve();
                    } else {
                        invoice.loading = true;
                        axios.post('/invoices/pay', {id: invoice.id}).then((res) => {
                            if(res.data.meta.payment_status === "SUCCESS"){
                                if(this.getCurrency(invoice) === "SEK"){
                                    this.totalChargedSEK += invoice.balance - res.data.balance;
                                }else{
                                    this.totalChargedGBP += invoice.balance - res.data.balance;
                                }
                            }else if (res.data.meta.payment_status === "SKIPPED"){
                                if(this.getCurrency(invoice) === "SEK"){
                                    this.totalAlreadyPaidSEK += invoice.balance - res.data.balance;
                                }else{
                                    this.totalAlreadyPaidGBP += invoice.balance - res.data.balance;
                                }
                            }
                            invoice.balance = res.data.balance;
                            invoice.loading = false;
                            resolve();
                        }).catch(err => {
                            console.log(err);
                            if(this.getCurrency(invoice) === "SEK"){
                                this.totalNotChargedSEK += invoice.balance;
                            }else{
                                this.totalNotChargedGBP += invoice.balance;
                            }
                            invoice.loading = false;
                            resolve();
                        });
                    }
                })),
                Promise.resolve()
            ).then(() => {
                this.paymentsInProcess = false;
                this.cancelClicked = false;
                this.invoicesForPayment = null;
            });
        },
        clearData(){
            this.invoicesForPayment = null;
            this.paymentsInProcess = false;
            this.cancelClicked = false;
            this.isConfirmationState = false;
            this.totalChargedSEK = 0;
            this.totalNotChargedSEK = 0;
            this.totalChargedGBP = 0;
            this.totalNotChargedGBP = 0;
            this.totalAlreadyPaidSEK = 0;
            this.totalAlreadyPaidGBP = 0;
        }
    }
}
</script>

<style scoped>
    .payAll{
        padding: 6px 28px;
        width: auto;
        font-size: 16px;
    }
</style>
